import React, { createContext, useContext, useState } from 'react';

const ClientUserStateContext = createContext();

export const ClientUserStateProvider = ({ children }) => {
  const [clientUser, setClientUser] = useState({
    ClientName: "",
    AddressId: 0,
    CompanyAddressLine1: "",
    CompanyAddressLine2: "",
    City: "",
    StateAndProvince: "",
    CountryId: 1,
    ZipCode: "",
    FirstName: "",
    LastName: "",
    Email: "",
    PhoneNumber: "",
    OPIPin: "",
    Roles: [],
    IsAdmin: false,
  });

  return (
    <ClientUserStateContext.Provider value={{
      clientUser, setClientUser
    }}>
      {children}
    </ClientUserStateContext.Provider>
  );
};

export const useClientUserState = () => useContext(ClientUserStateContext);
